import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type TTable = {
    name: string;
    _id: string;
    status: boolean;
    businessId: string;
    sort: number;
    isAvailable?: boolean;
}

export interface Notification {
    businessId: string
    tableId: string
    orderNo: string
    date: string
    message: string
    paymentStatus: boolean
    exchangeRate: number
    vat: number
    subTotal: number
    total: number
    orderStatus: number
    table: TTable
    status: boolean
    _id: string
    __v: number
}

interface NotificationState {
    notifications: Notification[];
}

const initialState: NotificationState = {
    notifications: [],
};

const notificationSlice = createSlice({
    name: 'notification',
    initialState,
    reducers: {
        addNotification: (state, action: PayloadAction<Notification>) => {
            state.notifications.push(action.payload);
        },
        removeNotification: (state, action: PayloadAction<string>) => {
            state.notifications = state.notifications.filter(
                (notification) => notification._id !== action.payload
            );
        },
    },
});

export const { addNotification, removeNotification } = notificationSlice.actions;

export default notificationSlice.reducer;